var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.tab === 'uploadByImage' ? 'EinvoiceUploadByImage' : 'EinvoiceUploadManually', {
    tag: "component",
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function fn() {
        return [_c('CouponFilters', {
          staticClass: "s-mb-3",
          attrs: {
            "options": _vm.tabOptions
          },
          on: {
            "input": function input(tab) {
              return _vm.$router.replace({
                query: {
                  tab: tab
                }
              });
            }
          },
          model: {
            value: _vm.tab,
            callback: function callback($$v) {
              _vm.tab = $$v;
            },
            expression: "tab"
          }
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }